module.exports = __webpack_public_path__ + "static/img/normal page top img_mobile.90d5b8ef.jpg";